import { fbq } from '@/site/analytics/trackers'
import { shopApi } from './plugin_shop-api'
import store from '@/site/store'
import Srv from '@/__shared/utils/lib_srv'


function normalizeOrderData(order) {
	let numItems = 0
	let contents = order.items.map((item) => {
		numItems += item.qty
		let content = {
			id: item.sku,
			quantity: item.qty,
			title: item.name,
			variant: item.variantName,
			description: item.variantName,
			price: item.finalPrice,
			item_price: item.finalPrice,
		}
		if (item.customData?.brand?.name) {
			content.brand = item.customData.brand.name
		}
		if (item.customData?.categories?.length) {
			content.category = item.customData.categories.map((c) => c.name).join(' > ')
		}
		return content
	})

	return {
		value: order.total,
		currency: order.currency.iso,
		content_type: 'product',
		num_items: numItems,
		contents,
	}
}

function normalizeUserData(user) {
	let data = {
		external_id: user.id,
		email: user.accountEmail,
		// last_name: user.lastname,
		// first_name: user.firstname,
	}
	if (user.fullPhone) data.phone = user.fullPhone
	if (user.facebookId) data.fb_login_id = user.facebookId
	return data
}

function normalizeProductData(product, variant) {
	let { price } = variant.pvPrice
	let currency = variant.pvPrice.priceConfig.currency.iso
	let value = price
	let description = variant.attrs?.map((attr) => `${attr.attrKey.k} ${attr.v}`).join(' / ') || ''
	let content = {
		id: variant.sku,
		quantity: 1,
		title: product.name,
		description: description,
		variant: description,
		item_price: price,
		price,
	}

	if (product.brand) content.brand = product.brand.name
	if (product.categories?.length) content.category = product.categories.map((c) => c.name).join(' > ')

	return {
		contents: [content],
		currency,
		value,
		content_type: 'product',
		num_items: 1,
	}
}

function generateUUID(userId) {
	// Generate 16 random bytes
	const arr = new Uint8Array(16)
	window.crypto.getRandomValues(arr)

	// Convert the bytes to a UUID string format
	arr[6] = (arr[6] & 0x0f) | 0x40 // Version 4
	arr[8] = (arr[8] & 0x3f) | 0x80 // Variant 10xx

	let res = Array.from(arr)
		.map((b) => {
			const hex = b.toString(16).padStart(2, '0')
			return hex
		})
		.join('')
		.replace(/^(.{8})(.{4})(.{4})(.{4})(.{12})$/, '$1-$2-$3-$4-$5')

	res = `${res}-${Date.now()}`
	if (userId) {
		res += `-${userId}`
	}
	return res
}

async function triggerDoubleEvent(eventName, data) {
	const storeUser = store.get('shop/user')
	const eventID = generateUUID(storeUser?.id)
	fbq('track', eventName, data, { eventID })

	if (!Srv('Analytics.useFbpApi')) return
	const pxEvData = { eventID, data, eventName }
	if (storeUser) {
		const { accountEmail, fullPhone, id, facebookId } = storeUser
		pxEvData.user = { accountEmail, fullPhone, id, facebookId }
	}
	await shopApi.post({ url: '/fb-pixel-event', data: pxEvData }).catch(() => null)
}

export default {
	normalizeOrderData,
	normalizeUserData,
	normalizeProductData,
	triggerDoubleEvent,
}

